import { Pipe, PipeTransform } from '@angular/core';
import { Product, ProductGroupInfo } from '../../models/organization.model';

@Pipe({
  name: 'categoryHasProduct'
})
export class CategoryHasProductPipe implements PipeTransform {

  transform(categories: ProductGroupInfo[], products: Product[]): ProductGroupInfo[] {
    return categories.filter(category => {
      return !category.isGroupModifier &&
        !!(products.find(product => product.productGroupInfo && product.productGroupInfo.id === category.id));
    });
  }

}
